/** One shared column width so every element in a library view lines up. */
export const LIBRARY_COLUMN_MAX_WIDTH = 560;
